import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialog, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { Person, TenantUnitDetail, TenantUnitService } from '@eadsysteme/ewsrealestateclient-v3';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RealEstatesSelectDialogComponent } from '../real-estates-legacy/real-estates-select-dialog/real-estates-select-dialog.component';
import { RealEstateTableEntity } from '../real-estates-legacy/real-estates-legacy.component';
import { DateUtil } from '../../util/DateUtil';
import { BaseSelectByRealEstateDialogComponent } from '../shared/base-select-by-real-estate-dialog.component';
import { Observable } from 'rxjs';

@Component({
	selector: 'vex-select-tenantunit-by-realestate-dialog',
	imports: [
		CdkDrag,
		CdkDragHandle,
		MatButton,
		MatDialogActions,
		MatDialogContent,
		MatDialogTitle,
		TranslocoDirective,
		MatIcon,
		FormsModule,
		MatFormField,
		MatLabel,
		MatOption,
		MatSelect,
		ReactiveFormsModule,
		MatSelectTrigger,
		MatError,
		MatProgressSpinner,
		MatIconButton,
	],
	templateUrl: './select-tenant-unit-by-real-estate-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './select-tenant-unit-by-real-estate-dialog.component.scss',
})
export class SelectTenantUnitByRealEstateDialogComponent extends BaseSelectByRealEstateDialogComponent<TenantUnitDetail> {
	protected readonly dialogRef = inject(MatDialogRef<SelectTenantUnitByRealEstateDialogComponent>);
	private readonly tenantUnitService = inject(TenantUnitService);
	protected readonly translocoService = inject(TranslocoService);
	protected readonly dialog = inject(MatDialog);
	protected readonly dateUtil = inject(DateUtil);

	protected get tenantUnits() {
		return this.items;
	}

	protected get tenantUnitFc() {
		return this.itemFc;
	}

	protected fetchItems(realEstateId: string): Observable<TenantUnitDetail[]> {
		return this.tenantUnitService.getByRealEstateId(this.sessionService.effectiveArea, realEstateId);
	}

	protected loadTenantUnits(initialLoad: boolean = false): void {
		this.loadItems(initialLoad);
	}

	protected close(saved: boolean): void {
		const result = saved ? { saved, realEstateContact: this.realEstateFc.value, tenantUnit: this.tenantUnitFc.value } : { saved };
		this.dialogRef.close(result);
	}

	protected getPersonName(person: Person): string {
		return person?.fullName ? person.fullName : [person?.givenName, person?.familyName].join(' ');
	}

	protected openRealEstatesSelectDialog(): void {
		const dialogRef = this.dialog.open(RealEstatesSelectDialogComponent, {
			width: '1200px',
			maxWidth: '95vw',
			maxHeight: '80vh',
		});

		dialogRef.afterClosed().subscribe((result: RealEstateTableEntity | null) => {
			if (!result) {
				return;
			}
			this.realEstateFc.setValue(this.realEstates().find((realEstate) => realEstate.realEstateId === result.realEstateId));
			this.loadTenantUnits(false);
		});
	}
}
